import React, { useContext, useEffect, useState } from 'react'
import ConsultasComunes from '../Sql/ConsultasComunes'
import Modal from 'react-bootstrap/Modal';
import MsgUtils from '../Tools/MsgUtils';
import UtilsBufer from '../Tools/UtilsBufer';
import { ContextGloball } from '../Context/ContextGlobal';
import DateConverter from '../Tools/DateConverter';
import valPer from '../Tools/VerificarPermisos';
import ConsultasFormularios from '../Sql/ConsultasFormularios';
import EditarDestinoFormulario from '../Formularios/EditarDestinoFormulario';
import ListaFormularios from '../Formularios/ListaFormularios';
import EncuestaRespond from '../Formularios/EncuestaRespond';
import RespuestaFormularios from '../Formularios/RespuestaFormularios';

function ColaboradoresPrueba() {
    const { setLoading } = useContext(ContextGloball);
    const [infoUser,setInfoUser] = useState(null);
    const [colaborador, setColaborador] = useState([]);
    const [ventana, setVentana] = useState(0);
    const [selectEmpleado, setSelectEmpleado] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [selectExamen, setSelectExamen] = useState(null);
    const [listaExamenes, setListaExamenes] = useState([]);
    const [observaciones, setObservaciones] = useState('');
    const [tipoModal, setTipoModal] = useState();
    const [regional,setRegional] = useState('');
    const getColaboradores = async (info) => {
        setLoading(true);
        try {
            var respuesta = await ConsultasComunes.getColaboradoresPrueba({ 'regional': info.regional });
            if (respuesta.ok) {
                setColaborador(respuesta.ok);
            } else {
                MsgUtils.msgError(respuesta.error);
            }
        } catch (error) {
            MsgUtils.msgError(error.message);
        } finally {
            setLoading(false);
        }
    }
    const actualizarListaPruebas = async (datos) => {
        setLoading(true)
        try {
            var parametros = {
                'regional': infoUser.regional,
                'V_ID_CONTRATACION': datos.ID_CONTRATACION
            }
            var resultado = await ConsultasFormularios.getEvaluacionesColaborador(parametros);
            if (resultado.ok) {
                setListaExamenes(resultado.ok);
            } else {
                MsgUtils.msgError(resultado.error);
            }
        } catch (error) {
            MsgUtils.msgError(error.message);
        } finally {
            setLoading(false);
        }
    }
    function agregarEvaluacion(dato) {
        console.log(dato)
        setSelectExamen(dato);
    }
    var EliminarFormulario = async (dato) => {
        var datos = JSON.parse(localStorage.getItem('__react_session__'));
        try {
            var parametros = {
                'regional': datos.regional,
                'idEvaluacion': dato.ID_EVALUACION,
                'idContratacion': dato.ID_CONTRATACION,
                'idEncuesta': dato.ID_ENCUESTA,
                'observaciones': UtilsBufer.getText(dato.OBSERVACIONES),
                'estado': 'E'
            }
            var resultado = await ConsultasFormularios.addContratacionEvaluacion(parametros);
            if (resultado.ok) {
                MsgUtils.msgCorrecto(resultado.ok);
            } else {
                MsgUtils.msgError(resultado.error);
            }
        } catch (error) {
            MsgUtils.msgError(error.message);
        } finally {
            await actualizarListaPruebas(dato);
        }
    }
    var agregarFormulario = async () => {
        setLoading(true);
        try {
            var parametros = {
                'regional': infoUser.regional,
                'idEvaluacion': 0,
                'idContratacion': selectEmpleado.ID_CONTRATACION,
                'idEncuesta': selectExamen.ID_ENCUESTA,
                'observaciones': observaciones,
                'estado': 'A'
            }
            var resultado = await ConsultasFormularios.addContratacionEvaluacion(parametros);
            if (resultado.ok) {
                setListaExamenes([...listaExamenes, { ...selectExamen, 'OBSERVACIONES': observaciones }]);
                setSelectExamen(null);
                setShowModal(false);
                MsgUtils.msgCorrecto(resultado.ok);
            } else {
                MsgUtils.msgError(resultado.error);
            }
        } catch (error) {
            MsgUtils.msgError(error.message);
        } finally {
            setLoading(false)
        }
    }
    const seleccionarEmpleado = async (datos, ventana) => {
        setLoading(true)
        try {
            var parametros = {
                'regional': infoUser.regional,
                'idEmpleado': datos.ID_EMPLEADO,
                'tipo':4
            }
            //var resultado = await ConsultasFormularios.getEvaluacionesColaborador(parametros);
            var resultado = await ConsultasFormularios.getFormulariosAsignados(parametros);
            if (resultado.ok) {
                setListaExamenes(resultado.ok);
                document.getElementById('btnSalirMenuRRHH').className = 'd-none'
                setSelectEmpleado(datos);
                setVentana(ventana)
            } else {
                MsgUtils.msgError(resultado.error);
            }
        } catch (error) {
            MsgUtils.msgError(error.message);
        } finally {
            setLoading(false);
        }
    }
    const guardarRespuesta = async (valor) => {
        try {
            var respuesta = await ConsultasFormularios.guardarRespuestaFormulario(
                {
                    'regional': infoUser.regional, 'ID_RESPUESTA': valor,
                    'ID_FORMULARIO': selectExamen.ID_FORMULARIO, 'ID_EMPLEADO': infoUser.idSession
                })
            if (respuesta.ok) {
                setShowModal(false);
            } else {
                MsgUtils.msgError(respuesta.error);
            }
        } catch (error) {
            MsgUtils.msgError(error.message);
        }
    }
    useEffect(() => {
        var info = JSON.parse(localStorage.getItem('__react_session__'))
        setRegional(info.regional);
        setInfoUser(info);
        getColaboradores(info)
    }, [])
    return (
        <>
            {ventana === 0 && <>
                <div className='container-fluid bg-dark'>
                    hola
                </div>
                <div className='table-responsive'>
                    <table className="table table-dark table-striped table-hover">
                        <thead className='text-center fw-bold'>
                            <tr>
                                <th style={{ width: '320px' }}>Colaborador</th>
                                <th style={{ width: '120px' }}>Sucursal</th>
                                <th style={{ width: '120px' }}>Fecha Inicio</th>
                                <th style={{ width: '120px' }}>Fecha Fin</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {colaborador.map((item, index) => {
                                return (
                                    <tr key={index}>
                                        <td className='' style={{ minWidth: '300px', maxWidth: '300px' }}>
                                            <div className="card bg-transparent flex-row m-0 p-0" style={{ border: 'none' }} >
                                                {UtilsBufer.getFotoCard(item.FOTO, 40)}
                                                <div className='ps-2 my-auto'>
                                                    <div className="cargoHeader fw-bold" id='buscareAqui'>{item.NOMBREX}</div>
                                                    <div className='cargoHeader '>{item.CARGO}</div>
                                                </div>
                                            </div>
                                        </td>
                                        <td className='my-auto'>{item.SUCURSAL}</td>
                                        <td>{DateConverter.formatoFechaNumeric(item.FECHA_INICIO)}</td>
                                        <td>{DateConverter.formatoFechaNumeric(item.FECHA_FINAL)}</td>
                                        <td>
                                            <div className='btn btn-group btn-group-sm'>
                                                <button className='btn btn-sm btn-secondary'
                                                    title='Evaluacion del colaborador'
                                                    onClick={() => seleccionarEmpleado(item, 1)}
                                                ><i className="fa-solid fa-file-signature"></i> Evaluaciones
                                                </button>
                                                {valPer.validarPermiso('61') &&
                                                    <button className='btn btn-sm btn-warning'
                                                        title='Ver respuestas de las encuestas del colaborador'
                                                        onClick={() => seleccionarEmpleado(item, 2)}
                                                    ><i className="fa-brands fa-resolving"></i> Respuestas
                                                    </button>}
                                            </div>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </>}
            {ventana != 0 &&
                <div className='container-fluid bg-dark bg-gradient'>
                    <div className='row row-cols g-1'>
                        <div className='col' style={{ minWidth: '250px', maxWidth: '250px' }}>
                            <div className="card bg-transparent flex-row m-0 p-0" style={{ border: 'none' }} >
                                {UtilsBufer.getFotoCard(selectEmpleado.FOTO, 40)}
                                <div className='ps-2 my-auto'>
                                    <div className="cargoHeader fw-bold text-light">{selectEmpleado.NOMBREX}</div>
                                    <div className='cargoHeader text-light'>{selectEmpleado.CARGO}</div>
                                </div>
                            </div>
                        </div>
                        <div className='col text-end my-auto'>
                            <button className='btn btn-sm btn-transparent my-auto text-light'
                                title='Atras a la lista de Colaboradores'
                                onClick={() => {
                                    if(ventana===3 ){
                                        setVentana(2)
                                    }else{
                                        setVentana(0);
                                        setSelectEmpleado({});
                                        document.getElementById('btnSalirMenuRRHH').className = 'btn text-danger btn-flotante'
                                    }
                                }}>
                                <i className="fa-solid fa-circle-xmark fa-2xl"></i>
                            </button>
                        </div>
                    </div>
                </div>}
            {[1, 2].indexOf(ventana) !== -1 &&
                <>
                    <div className='container-fluid bg-dark py-1'>
                        <div className='row row-cols gx-1'>
                            <div className='col col-10 text-light my-auto'>
                                Examenes Asociados al Colaborador
                            </div>
                            <div className='col col-2 text-end'>
                                {valPer.validarPermiso('61') && ventana === 1 &&
                                    <button className='btn btn-sm btn-success bg-gradient w-100'
                                        title='Agregar formulario'
                                        onClick={() => { setObservaciones(''); setSelectExamen(null); setShowModal(true); setTipoModal('N') }}
                                    >
                                        <i className="fa-solid fa-circle-plus"></i>
                                        Agregar
                                    </button>}
                            </div>
                        </div>
                    </div>
                    <div className='container-fluid m-0 p-0'>
                        <div className='table-responsive'>
                            <table className="table table-sm table-dark table-striped table-hover table-bordered border-light">
                                <thead className='text-center'>
                                    <tr>
                                        <th style={{ width: '140px' }}>Fecha</th>
                                        <th style={{ width: '160px' }}>Tipo</th>
                                        <th style={{ width: '250px' }}>Formulario</th>
                                        <th style={{ width: '350px' }}>Creado Por</th>
                                        <th style={{ width: '120px' }}></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {listaExamenes.map((item, index) => {
                                        return (
                                            <tr key={index}>
                                                <th>{DateConverter.formatoFecha(item.FECHA)}</th>
                                                <td>{item.TIPO_ENCUESTA}</td>
                                                <td>{item.TITULO}</td>
                                                <td>{item.NOMBREX}</td>
                                                <td>
                                                    <div className='btn-group btn-group-sm w-100'>
                                                        {ventana === 1 && <button className='btn btn-sm btn-light w-100'
                                                            onClick={() => { setSelectExamen(item); setTipoModal('R'); setShowModal(true); }}
                                                            title='Responder Evaluación'>
                                                            <i className="fa-solid fa-rectangle-list"></i> Responder
                                                        </button>}
                                                        {ventana === 2 && <button className='btn btn-sm btn-secondary w-100'
                                                            onClick={() => { setSelectExamen(item); setVentana(3); }}
                                                            title='Responder Evaluación'>
                                                            <i className="fa-solid fa-rectangle-list"></i> Respuestas
                                                        </button>}
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </>}
            {ventana === 3 &&<RespuestaFormularios selectFormulario={selectExamen} infoUser={infoUser} selectEmpleado={selectEmpleado}/>}
            <Modal show={showModal} onHide={() => setShowModal(false)}
                size="xl" backdrop="static"
                keyboard={false} centered
                aria-labelledby="contained-modal-title-vcenter"
                contentClassName='bg-dark bg-gradient'>
                <Modal.Header closeButton closeVariant='white' bsPrefix='modal-header m-0 p-0 px-2'>
                    <Modal.Title>
                        {tipoModal === 'N' && <div className='text-light'>Elija un formulario para el Examen</div>}
                        {tipoModal === 'R' && <div className='text-light'>Responder Examen</div>}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body bsPrefix='modal-body m-0 p-0'>
                    {tipoModal === 'N' && 
                    <ListaFormularios selectColaborador={selectEmpleado} 
                        collback={() => { setShowModal(false); seleccionarEmpleado(selectEmpleado, 1) }} 
                        tipo='VP' tipoFormulario={2} regional={regional}/>}
                    {tipoModal === 'R' && 
                        <EncuestaRespond selectFormu={selectExamen} soloVer={false} 
                            teclado={false} tipo='F' collback={(valor) => guardarRespuesta(valor)} reg={regional} userResp={selectEmpleado}/>}
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ColaboradoresPrueba